import { render } from "./UserPanel.vue?vue&type=template&id=dcc16356&scoped=true"
import script from "./UserPanel.vue?vue&type=script&lang=js"
export * from "./UserPanel.vue?vue&type=script&lang=js"

import "./UserPanel.vue?vue&type=style&index=0&id=dcc16356&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcc16356"]])

export default __exports__